import { net } from './pb';

import RoomSocket from './roomSocket';
import { BinaryEncoder } from './IMBinaryUtils';
import StringUtils from './IMStringUtils';
import S2C from './roomS2C';
import IMApp from './IMApp';


export default class C2S {
  static testS2C = new S2C();
  /**
   * 发送心跳包
   */
  static msg_heart_test() {
    var msg = new net.msg_heart_test();
    msg.svr_time = 1;
    let buffer = net.msg_heart_test.encode(msg).finish();
    RoomSocket.instance.sendData(net.CLIENT_MSG_ID.C2S_MSG_HEART, buffer); 
  }


  static msg_h5login_req(uid, key) {
    var msg = new net.msg_h5login_req();
    msg.uid = uid;
    msg.fastkey = BinaryEncoder.fromString(key);
    msg.deviceid = StringUtils.encode(IMApp.deviceid);
    msg.version = StringUtils.encode(IMApp.version);
    let buffer = net.msg_h5login_req.encode(msg).finish();
    RoomSocket.instance.sendData(net.CLIENT_MSG_ID.C2S_MSG_H5LOGIN, buffer);
  }

  /**
   * 登录到游戏server
   * @param uid 从php获取的用户ID
   * @param key 从php获取的用户Sessionkey
   */
  static msg_login_req(uid, key, phone) {
    var msg = new net.msg_login_req();
    msg.uid = uid;
    msg.fastkey = BinaryEncoder.fromString(key);
    msg.phonenum = BinaryEncoder.fromString(phone);
    msg.deviceid = StringUtils.encode(IMApp.deviceid);
    msg.version = StringUtils.encode(IMApp.version);
    let buffer = net.msg_login_req.encode(msg).finish();
    RoomSocket.instance.sendData(net.CLIENT_MSG_ID.C2S_MSG_LOGIN, buffer);
  }

  

  static get_room_history_msg(roomkey){
    //获取房间的聊天记录
    var msg = new net.msg_get_chatroom_history_msg();
    msg.roomkey = roomkey;
    let buffer = net.msg_get_chatroom_history_msg.encode(msg).finish()
    RoomSocket.instance.sendData(net.CLIENT_MSG_ID.C2S_MSG_GET_CHATROOM_HISTORY_MSG, buffer);
  }
 
  

  /**
   * 获取账单列表
   * @param {*} uid
   */
  static msg_get_money_change_list(uid) {
    var msg = new net.msg_get_money_change_list();
    let buffer = net.msg_get_money_change_list.encode(msg).finish();
    RoomSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_MONEY_CHANGE_LIST,
      buffer,
    );
  }
  /**
   * 获取我的挂单信息
   */
  static msg_get_my_goods() {
    var msg = new net.msg_get_my_goods();
    let buffer = net.msg_get_my_goods.encode(msg).finish();
    RoomSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_MY_GOODS,
      buffer,
    );
  }
  /**
   * 挂单
   * @param {*} goodsvalue 挂单金额
   * @param {*} minlimit 限额最低值
   * @param {*} maxlimit 限额最高值
   * @param {*} paylist 支持的交易方式,移动支付id列表
   * @param {*} cointype 1Fb 2其他
   * @param {*} rate 汇率(放大10000倍为整数)
   * @param {*} status 状态1开启2关闭
   * @param {*} goodstype 1充值2提现3兑换
   * @param {*} outcointype 兑换的时候COIN_TYPE_RMB,兑换成什么币种
   */
  static msg_create_goods(
    goodsvalue,
    minlimit,
    maxlimit,
    paylist,
    cointype,
    rate,
    status,
    goodstype,
    outcointype,
  ) {
    var msg = new net.msg_create_goods();
    msg.goodsvalue = goodsvalue;
    msg.minlimit = minlimit;
    msg.maxlimit = maxlimit;
    msg.paylist = paylist;
    msg.cointype = cointype;
    msg.rate = rate;
    msg.status = status;
    msg.goodstype = goodstype;
    if (goodstype == 3) {
      msg.outcointype = outcointype;
    }
    // console.log('msg_create_goods--->', msg);
    let buffer = net.msg_create_goods.encode(msg).finish();
    RoomSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_CREATE_GOODS,
      buffer,
    );
  }
  /**
   * 获取所有挂单消息
   * @param {*} paytype //0银行卡1支付宝2微信
   * @param {*} opertype//1充值 2提现 3兑换
   */
  static msg_get_goods(paytype, money_type, opertype, value) {
    var msg = new net.msg_get_goods();
    msg.cointype = money_type;
    if (opertype == 3) {
      msg.outcointype = paytype;
    } else {
      msg.paytype = paytype;
    }
    msg.opertype = opertype;
    msg.value = value;
    let buffer = net.msg_get_goods.encode(msg).finish();
    // console.log('msg===1===>', msg);
    RoomSocket.instance.sendData(net.CLIENT_MSG_ID.C2S_MSG_GET_GOODS, buffer);
  }
  /**
   * 创建订单
   * @param {*} opertype 1充值 2提现
   * @param {*} goodsid 选的哪个goods
   * @param {*} ordervalue 订单金额
   * @param {*} paytype 支付方式
   */
  static msg_create_order(opertype, goodsid, ordervalue, paytype) {
    var msg = new net.msg_create_order();
    msg.opertype = opertype;
    msg.goodsid = goodsid;
    msg.ordervalue = ordervalue;
    msg.paytype = paytype;
    let buffer = net.msg_create_order.encode(msg).finish();
    // console.log('msg======>', msg);
    RoomSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_CREATE_ORDER,
      buffer,
    );
  }
  /**
   * 确认订单
   * @param {*} orderid
   */
  static msg_confirm_order(orderid) {
    var msg = new net.msg_confirm_order();
    msg.orderid = orderid;
    let buffer = net.msg_confirm_order.encode(msg).finish();
    // console.log('msg======>', msg);
    RoomSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_CONFIRM_ORDER,
      buffer,
    );
  }
  /**
   * 获取我相关的订单
   */
  static msg_get_my_orders() {
    var msg = new net.msg_get_my_orders();
    let buffer = net.msg_get_my_orders.encode(msg).finish();
    // console.log('msg======>', msg);
    RoomSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_MY_ORDERS,
      buffer,
    );
  }
  /**
   * 获取与某商户的订单
   * @param {*} otheruid
   */
  static msg_get_order_info(otheruid) {
    // console.log(
    //   'get_goods_detail------->44444444444444444444',
    //   '444444444444444444--------' + otheruid,
    // );
    var msg = new net.msg_get_order_info();
    msg.otheruid = otheruid;
    let buffer = net.msg_get_order_info.encode(msg).finish();
    // console.log('msg======>', msg);
    RoomSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_ORDER_INFO,
      buffer,
    );
  }
  /**
   * 获取某个挂单
   * @param {*} goodsid
   */
  static msg_get_goods_byid(goodsid) {
    var msg = new net.msg_get_goods_byid();
    msg.goodsid = goodsid;
    let buffer = net.msg_get_goods_byid.encode(msg).finish();
    // console.log('msg======>', msg);
    RoomSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_GOODS_BYID,
      buffer,
    );
  }

  static msg_withdraw_chatmsg(chatkey, chatmsgno) {
    var msg = new net.msg_withdraw_chatmsg();
    msg.chatkey = chatkey;
    msg.otheruid = chatmsgno;
    let buffer = net.msg_withdraw_chatmsg.encode(msg).finish();
    RoomSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_WITHDRAW_CHATMSG,
      buffer,
    );
  }

  static msg_confirm_hasread_msg(chatkey, chatmsgno_list) {
    var msg = new net.msg_confirm_hasread_msg();
    msg.chatkey = chatkey;
    msg.chatmsgno_list = chatmsgno_list;
    let buffer = net.msg_confirm_hasread_msg.encode(msg).finish();
    RoomSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_CONFIRM_HASREAD_MSG,
      buffer,
    );
  }

  static requestTimeout = null;
  static chatmsgno_list = [];
  static msg_get_hasread_list(chatkey, chatmsgno_list) {
    C2S.chatmsgno_list = chatmsgno_list;
    C2S.chatkey = chatkey;
    clearTimeout(C2S.requestTimeout);
    let fun = list => {
      var msg = new net.msg_get_hasread_list();
      msg.chatkey = chatkey;
      msg.chatmsgno_list = list;
      let buffer = net.msg_get_hasread_list.encode(msg).finish();
      RoomSocket.instance.sendData(
        net.CLIENT_MSG_ID.C2S_MSG_GET_HASREAD_LIST,
        buffer,
      );
      C2S.requestTimeout = setTimeout(() => {
        if (C2S.chatmsgno_list.length > 0) {
          fun(C2S.chatmsgno_list);
        }
      }, 3000);
    };
    fun(C2S.chatmsgno_list);
  }

  static updateUnreadlist(chatkey, clientkey, chatmsgno) {
    if (C2S.chatkey != chatkey) {
      return;
    }
    for (let i = 0; i < C2S.chatmsgno_list.length; i++) {
      if (C2S.chatmsgno_list[i] == clientkey) {
        C2S.chatmsgno_list[i] = chatmsgno;
      }
    }
  }

  static cancelRequestUnread() {
    C2S.requestTimeout && clearTimeout(C2S.requestTimeout);
    C2S.requestTimeout = null;
  }

  static msg_get_group_nickname_list(groupkey) {
    var msg = new net.msg_get_group_nickname_list();
    msg.groupkey = groupkey;
    // console.log('msg_get_group_nickname_list-->', msg);
    let buffer = net.msg_get_group_nickname_list.encode(msg).finish();
    // console.log(buffer);
    RoomSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_GROUP_NICKNAME_LIST,
      buffer,
    );
  }

  static msg_set_group_nickname(groupkey, nickname) {
    var msg = new net.msg_set_group_nickname();
    msg.groupkey = groupkey;
    msg.nickname = StringUtils.encode(nickname);
    let buffer = net.msg_set_group_nickname.encode(msg).finish();
    RoomSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_SET_GROUP_NICKNAME,
      buffer,
    );
  }
  /**
   * 取消订单
   * @param {} orderid
   */
  static msg_cancel_order(orderid) {
    var msg = new net.msg_cancel_order();
    msg.orderid = orderid;
    let buffer = net.msg_cancel_order.encode(msg).finish();
    RoomSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_CANCEL_ORDER,
      buffer,
    );
  }

  /**
   * 修改支付方式
   * @param {*} orderid
   * @param {*} paytype
   * @param {*} paytypeid
   */
  static msg_set_order_paytypeid(orderid, paytype, paytypeid) {
    var msg = new net.msg_set_order_paytypeid();
    msg.orderid = orderid;
    msg.paytype = paytype;
    msg.paytypeid = paytypeid;
    let buffer = net.msg_set_order_paytypeid.encode(msg).finish();
    RoomSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_SET_ORDER_PAYTYPEID,
      buffer,
    );
  }
  /**
   * 获取商品数据(今日笔数和金额)
   * @param {*} goodstype 1充值2提现
   */
  static msg_get_goods_data() {
    var msg = new net.msg_get_goods_data();
    let buffer = net.msg_get_goods_data.encode(msg).finish();
    RoomSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_GOODS_DATA,
      buffer,
    );
  }
  

  /** 加入聊天室 */

  static msg_join_chatroom(roomKey) {
    var msg = new net.msg_join_chatroom();
    msg.roomkey = roomKey;
    let buffer = net.msg_join_chatroom.encode(msg).finish();
    RoomSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_JOIN_CHATROOM,
      buffer,
    );
  }

  static msg_quit_chatroom(roomKey) {
    var msg = new net.msg_quit_chatroom();
    msg.roomkey = roomKey;
    let buffer = net.msg_quit_chatroom.encode(msg).finish();
    RoomSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_QUIT_CHATROOM,
      buffer,
    );
  }

  static msg_send_chatroom_msg(roomkey, msg_type, content) {
    var msg = new net.msg_send_chatroom_msg();
    msg.roomkey = roomkey;
    msg.msg_type = msg_type;
    msg.content = StringUtils.encode(content);
    let buffer = net.msg_send_chatroom_msg.encode(msg).finish();
    RoomSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_SEND_CHATROOM_MSG,
      buffer,
    );
  }

  static msg_chatroom_kickout(roomkey, kickuid) {
    var msg = new net.msg_chatroom_kickout();
    msg.roomkey = roomkey;
    msg.kickuid = kickuid;
    let buffer = net.msg_chatroom_kickout.encode(msg).finish();
    RoomSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_CHATROOM_KICKOUT,
      buffer,
    );
  }

  static msg_chatroom_forbid(roomkey, uid, is_set) {
    var msg = new net.msg_chatroom_forbid();
    msg.roomkey = roomkey;
    msg.uid = uid;
    msg.is_set = is_set;
    let buffer = net.msg_chatroom_forbid.encode(msg).finish();
    RoomSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_CHATROOM_FORBID,
      buffer,
    );
  }

  static msg_chatroom_admin(roomkey, uid, is_set) {
    var msg = new net.msg_chatroom_admin();
    msg.roomkey = roomkey;
    msg.uid = uid;
    msg.is_set = is_set;
    let buffer = net.msg_chatroom_admin.encode(msg).finish();
    RoomSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_CHATROOM_SET_ADMIN,
      buffer,
    );
  }

  static msg_del_chatroom_msg(roomkey, msgno) {
    var msg = new net.msg_del_chatroom_msg();
    msg.roomkey = roomkey;
    msg.msgno = msgno;
    let buffer = net.msg_del_chatroom_msg.encode(msg).finish();
    RoomSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_DEL_CHATROOM_MSG,
      buffer,
    );
  }


  static msg_get_chatroom_list() {
    var msg = new net.msg_get_chatroom_list();
    let buffer = net.msg_get_chatroom_list.encode(msg).finish();
    RoomSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_CHATROOM_LIST,
      buffer,
    );
  }

  static msg_get_chatroom_members(roomkey, page, limit) {
    var msg = new net.msg_get_chatroom_members();
    msg.roomkey = roomkey;
    msg.page = page;
    msg.limit = limit;
    let buffer = net.msg_get_chatroom_members.encode(msg).finish();
    RoomSocket.instance.sendData(
      net.CLIENT_MSG_ID.C2S_MSG_GET_CHATROOM_MEMBERS,
      buffer,
    );
  }

  

}
